import React from 'react';
import { Target, TrendingUp, ShieldCheck, Zap } from 'lucide-react';
import { Card } from '../ui';

export const CompanyOverviewBanner: React.FC = () => {
  const highlights = [
    { icon: <Target className="text-[#4a82c2] dark:text-sky-400" size={24} />, title: 'ROI First', subtitle: 'Measurable Value' },
    { icon: <ShieldCheck className="text-[#356aa5] dark:text-indigo-400" size={24} />, title: 'Smart Costing', subtitle: 'Practical Tech Choices' },
    { icon: <TrendingUp className="text-emerald-600 dark:text-emerald-400" size={24} />, title: 'Long-Term', subtitle: 'Maintainable Systems' },
    { icon: <Zap className="text-amber-500 dark:text-amber-400" size={24} />, title: 'Innovation', subtitle: 'Applied Real Solutions' },
  ];

  return (
    <section className="py-12 relative z-20 -mt-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Card variant="glass" className="p-6 sm:p-8 bg-white/90 dark:bg-slate-900/80 border border-slate-200 dark:border-slate-800/90 shadow-2xl backdrop-blur-2xl">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 divide-y md:divide-y-0 md:divide-x divide-slate-200 dark:divide-slate-800">
            {highlights.map((item, idx) => (
              <div key={idx} className={`flex items-center gap-4 ${idx !== 0 ? 'pt-4 md:pt-0 md:pl-6' : ''}`}>
                <div className="p-3 rounded-2xl bg-sky-50 dark:bg-slate-950/80 border border-slate-200 dark:border-slate-800/80 shrink-0">
                  {item.icon}
                </div>
                <div>
                  <h4 className="text-sm font-bold text-[#184166] dark:text-white tracking-tight">{item.title}</h4>
                  <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">{item.subtitle}</p>
                </div>
              </div>
            ))}
          </div>
        </Card>
      </div>
    </section>
  );
};
